import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import InitializeAnalytics from '../../components/InitializeAnalytics';
// import DevTools from './DevTools';
import './styles.scss';
import createApolloClient from '../../store/apollo-client';
import AuthContextProvider from '../../contexts/authContext';
import SnapshotNavContextProvider from '../../contexts/SnapshotNavContext';

const propTypes = {
  error: PropTypes.bool,
};

const defaultProps = {
  error: false,
};

const queryClient = new QueryClient();

const Root = ({ store, history }) => {
  const apolloStore = createApolloClient();
  return (
    <div>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <ApolloProvider client={apolloStore}>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <SnapshotNavContextProvider>
                <div>
                  <InitializeAnalytics history={history} store={store} />
                  {/* {process.env.NODE_ENV === 'development' ? <DevTools /> : null} */}
                </div>
              </SnapshotNavContextProvider>
            </Provider>
          </QueryClientProvider>
        </ApolloProvider>
      </CookiesProvider>
    </div>
  );
};

Root.propTypes = propTypes;
Root.defaultProps = defaultProps;

export default Root;
